import React, { useCallback, useState } from "react";
import {IconButton, ListItemIcon, ListItemText, Menu, MenuItem} from "@mui/material";
import { MoreVert } from "@mui/icons-material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

function ListItemMenu ({children, disabled = false, onEdit, editLabel = 'Edit', onDelete, deleteLabel = 'Delete'}) {
    const [open, setOpen] = useState(false);
    const [anchor, setAnchor] = useState(false);

    const closeMenu = () => {
        setOpen(false);
        setAnchor(false);
    }

    const openMenu = useCallback((target) => {
        setAnchor(target);
        setOpen(true);
    }, []);

    const handleEdit = useCallback(() => {
        onEdit();
        closeMenu();
    }, [onEdit]);

    const handleDelete = useCallback(() => {
        onDelete();
        closeMenu();
    }, [onDelete]);

    if (!onEdit && !onDelete && !children) return null;

    return (
        <>
            <IconButton
                edge="end"
                aria-label="options"
                onClick={({currentTarget}) => openMenu(currentTarget)}
                sx={{marginRight: '2px'}}
                disabled={disabled}
            >
                <MoreVert/>
            </IconButton>
            <Menu
                open={open}
                onClose={closeMenu}
                anchorEl={anchor}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {children}
                {!!onEdit && (
                    <MenuItem onClick={handleEdit} disabled={disabled}>
                        <ListItemIcon sx={{marginRight: '16px'}}><EditOutlinedIcon /></ListItemIcon>
                        <ListItemText sx={{minWidth: '140px'}}>{editLabel}</ListItemText>
                    </MenuItem>
                )}

                {!!onDelete && (
                    <MenuItem onClick={handleDelete} disabled={disabled}>
                        <ListItemIcon sx={{marginRight: '16px'}}><DeleteOutlinedIcon /></ListItemIcon>
                        <ListItemText sx={{minWidth: '140px'}}>{deleteLabel}</ListItemText>
                    </MenuItem>
                )}
                </Menu>

        </>
    );
}

export default ListItemMenu;
